import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import Heading from "../common/ui/Heading";
import ShareImg from "../../../src/assets/images/webp/why-share-img.webp";

const WhyShare = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="flex items-center justify-between max-lg:flex-col-reverse gap-[65px] max-lg:gap-10 max-sm:gap-5 w-full max-w-[1052px] mx-auto">
          <div className="w-full max-w-[496px] max-lg:max-w-full">
            <img src={ShareImg} alt="Share image" className="w-full h-auto" />
          </div>
          <div className="">
            <BlueHeading
              lineClassOne="sm:!hidden"
              text="Why We Share These Recognitions"
              className="max-sm:justify-center"
            />
            <Heading className="max-sm:text-center">
              Why We Share These Recognitions
            </Heading>
            <p className="text-[#686868] text-base font-normal leading-[150%] ff-jakarta pt-[13px] max-sm:text-center">
              Every award is a milestone that fuels our mission at Makeway
              India. We believe when one person is honored, it uplifts the
              entire team and every young dreamer connected to our vision.
            </p>
          </div>
        </div>
      </div>
      <div className="h-[230px] max-lg:h-[130px] max-sm:h-[200px]"></div>
    </>
  );
};

export default WhyShare;
